import clsx from "clsx";

export const TextPlaceholder = (props: { fullWidth?: boolean }) => {
    const { fullWidth } = props;

    return (
        <div className={clsx("placeholder-glow", fullWidth && "w-100")}>
            <div className="placeholder col-12"></div>
        </div>
    );
};
